import { useState } from 'react'
// import { callMintNft } from '../helpers/api'
// import { Fragment } from '../../common/schema/users/fragments'

export const useNftMint = () => {
  const [isMinting, setIsMinting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const mintNft = async () => {
    try {
      setIsMinting(true)
      setError(null)

      alert('NFT minting functionality is building. Thanks for your patience.')

      // const result = await callMintNft({
      //   fragmentId: fragment.cardId,
      //   fragmentCount,
      // })

      // if (!result.success) {
      //   throw new Error('Failed to mint NFT')
      // }

      // return result.response.data.mintedNft
    } catch (err) {
      console.error('Error minting NFT:', err)
      setError(err instanceof Error ? err.message : 'Failed to mint NFT')
      throw err
    } finally {
      setIsMinting(false)
    }
  }

  return {
    mintNft,
    isMinting,
    error,
  }
}
